// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container Styling */
.internshipContainer {
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: white;
    font-family: Arial, sans-serif;
  }
  
  /* Tab Styling */
  .tabContainer {
    display: flex;
    border-bottom: 2px solid #007bff;
    margin-bottom: 10px;
  }
  
  .tabContainer button {
    background: none;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    color: #333;
    transition: color 0.3s ease, border-bottom 0.3s ease;
  }
  
  .tabContainer button.active {
    border-bottom: 3px solid #007bff;
    color: #007bff;
    font-weight: bold;
  }
  
  .tabContainer button:hover {
    color: #0056b3;
  }
  
  /* Table Styling */
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  th,
  td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
  }
  
  th {
    background-color: #f5f5f5;
    font-weight: bold;
    color: #333;
  }
  
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  tr:hover {
    background-color: #f1faff;
    transition: background-color 0.3s ease;
  }
  
  /* Resume Link Styling */
  td a {
    color: #007bff;
    text-decoration: none;
    font-weight: bold;
  }
  
  td a:hover {
    text-decoration: underline;
    color: #0056b3;
  }
  
  /* Action Buttons */
  .acceptButton,
  .declineButton {
    padding: 8px 12px;
    margin: 5px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;
  }
  
  .acceptButton {
    background-color: #28a745; /* Green */
  }
  
  .declineButton {
    background-color: #dc3545; /* Red */
  }
  
  .acceptButton:hover {
    background-color: #218838; /* Darker Green */
  }
  
  .declineButton:hover {
    background-color: #c82333; /* Darker Red */
  }
  
  /* Responsive Design */
  /* @media (max-width: 768px) {
    th,
    td {
      font-size: 12px;
      padding: 8px;
    }
  
    .tabContainer button {
      font-size: 14px;
      padding: 8px 12px;
    }
  
    .acceptButton,
    .declineButton {
      padding: 6px 10px;
      font-size: 12px;
    }
  }
   */`, "",{"version":3,"sources":["webpack://./src/components/studentComponents/internshipPageContent.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,oDAAoD;EACtD;;EAEA;IACE,gCAAgC;IAChC,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sCAAsC;EACxC;;EAEA,wBAAwB;EACxB;IACE,cAAc;IACd,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;EAChB;;EAEA,mBAAmB;EACnB;;IAEE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB,EAAE,UAAU;EACvC;;EAEA;IACE,yBAAyB,EAAE,QAAQ;EACrC;;EAEA;IACE,yBAAyB,EAAE,iBAAiB;EAC9C;;EAEA;IACE,yBAAyB,EAAE,eAAe;EAC5C;;EAEA,sBAAsB;EACtB;;;;;;;;;;;;;;;;;;IAkBE","sourcesContent":["/* Container Styling */\n.internshipContainer {\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    background-color: white;\n    font-family: Arial, sans-serif;\n  }\n  \n  /* Tab Styling */\n  .tabContainer {\n    display: flex;\n    border-bottom: 2px solid #007bff;\n    margin-bottom: 10px;\n  }\n  \n  .tabContainer button {\n    background: none;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 16px;\n    color: #333;\n    transition: color 0.3s ease, border-bottom 0.3s ease;\n  }\n  \n  .tabContainer button.active {\n    border-bottom: 3px solid #007bff;\n    color: #007bff;\n    font-weight: bold;\n  }\n  \n  .tabContainer button:hover {\n    color: #0056b3;\n  }\n  \n  /* Table Styling */\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n  }\n  \n  th,\n  td {\n    border: 1px solid #ddd;\n    padding: 10px;\n    text-align: center;\n  }\n  \n  th {\n    background-color: #f5f5f5;\n    font-weight: bold;\n    color: #333;\n  }\n  \n  tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  tr:hover {\n    background-color: #f1faff;\n    transition: background-color 0.3s ease;\n  }\n  \n  /* Resume Link Styling */\n  td a {\n    color: #007bff;\n    text-decoration: none;\n    font-weight: bold;\n  }\n  \n  td a:hover {\n    text-decoration: underline;\n    color: #0056b3;\n  }\n  \n  /* Action Buttons */\n  .acceptButton,\n  .declineButton {\n    padding: 8px 12px;\n    margin: 5px;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .acceptButton {\n    background-color: #28a745; /* Green */\n  }\n  \n  .declineButton {\n    background-color: #dc3545; /* Red */\n  }\n  \n  .acceptButton:hover {\n    background-color: #218838; /* Darker Green */\n  }\n  \n  .declineButton:hover {\n    background-color: #c82333; /* Darker Red */\n  }\n  \n  /* Responsive Design */\n  /* @media (max-width: 768px) {\n    th,\n    td {\n      font-size: 12px;\n      padding: 8px;\n    }\n  \n    .tabContainer button {\n      font-size: 14px;\n      padding: 8px 12px;\n    }\n  \n    .acceptButton,\n    .declineButton {\n      padding: 6px 10px;\n      font-size: 12px;\n    }\n  }\n   */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
